/**
 * Security utilities for preventing prototype pollution and other attacks
 */

/**
 * Set of unsafe property keys that can lead to prototype pollution
 */
export const UNSAFE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

/**
 * Check if a key is safe to use for object property assignment
 * @param {string} key - The property key to check
 * @returns {boolean} - True if the key is safe, false otherwise
 */
export function isSafeKey(key) {
  return !UNSAFE_KEYS.has(key);
}

/**
 * Check if a key is unsafe (can cause prototype pollution)
 * @param {string} key - The property key to check
 * @returns {boolean} - True if the key is unsafe, false otherwise
 */
export function isUnsafeKey(key) {
  return UNSAFE_KEYS.has(key);
}

/**
 * Safe hasOwnProperty check that works even if the object shadows hasOwnProperty
 * @param {object} obj - The object to check
 * @param {string} key - The property key to check
 * @returns {boolean} - True if the object has the property, false otherwise
 */
export function hasOwnProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
